import Popover from './Popover';
import PopoverBody from './PopoverBody';
import PopoverHeader from './PopoverHeader';

export {
    PopoverBody,
    PopoverHeader
};

export default Popover;
